import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.gray50};
  padding: 70px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 90px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 110px 40px;
  }

  .inner {
    max-width: 1100px;
    margin: 0 auto;
  }

  header {
    text-align: center;
    margin-bottom: 40px;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      margin-bottom: 56px;
    }
  }

  .eyebrow {
    display: inline-block;
    background: rgba(76, 79, 255, 0.08);
    color: ${CSSVars.blue500};
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 6px 12px;
    border-radius: 999px;
    margin-bottom: 14px;
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 28px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    margin: 0 0 12px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 36px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 44px;
    }
  }

  .lead {
    font-family: ${CSSVars.secondaryFont};
    font-size: 16px;
    color: #4b5563;
    margin: 0;
  }

  .tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-bottom: 28px;
  }

  .tab {
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray200};
    border-radius: 999px;
    padding: 10px 20px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 500;
    font-size: 14px;
    color: #4b5563;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: ${CSSVars.blue500};
      color: ${CSSVars.blue500};
    }

    &.active {
      background: ${CSSVars.blue500};
      border-color: ${CSSVars.blue500};
      color: ${CSSVars.white};
    }
  }

  .panel {
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray100};
    border-radius: 18px;
    padding: 32px 28px;
    box-shadow: 0 4px 16px rgba(16, 24, 40, 0.04);

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      padding: 40px 36px;
    }

    ol {
      list-style: none;
      margin: 0 0 28px;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    li {
      display: flex;
      align-items: flex-start;
      gap: 14px;

      .step-num {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: linear-gradient(135deg, #5b5bff 0%, #a66cd9 50%, #f58a8a 100%);
        color: ${CSSVars.white};
        font-family: ${CSSVars.primaryFont};
        font-weight: 600;
        font-size: 13px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
      }

      .step-text {
        font-family: ${CSSVars.secondaryFont};
        font-size: 15px;
        line-height: 1.6;
        color: #1f2937;
        padding-top: 4px;
      }
    }

    .panel-cta {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-family: ${CSSVars.primaryFont};
      font-weight: 600;
      font-size: 15px;
      color: ${CSSVars.blue500};
      text-decoration: none;
      transition: gap 0.2s ease;

      &:hover {
        gap: 12px;
      }

      span {
        transition: transform 0.2s ease;
      }
      &:hover span {
        transform: translateX(2px);
      }
    }
  }
`;
